import React from 'react';

import { Project } from '../../../app/entities';
import { ShotLocationSelector } from '../../schedule/components/shot-location-selector';
import { Bloc, BlocContent } from '../../../routes/project/components/step-drawer';

interface LocationSelectProps {
  projectId: string;
  onChange: (value: string) => void;
  selectedLocationId: string | undefined;
}

export const LocationSelect: React.FC<LocationSelectProps> = ({
  projectId,
  onChange,
  selectedLocationId,
}) => {
  const project = Project.getOne(projectId)!;

  return (
    <ShotLocationSelector
      project={project}
      onChange={onChange}
      selectedLocationId={selectedLocationId}
      trigger={(value) => (
        <Bloc onClick={(e: React.MouseEvent) => e.stopPropagation()}>
          <label>Location</label>
          <BlocContent>{value}</BlocContent>
        </Bloc>
      )}
    />
  );
};
